<template>
    <div class="official-header">
        <div class="img-wrapper">
            <div
                class="top-mask"
                :style="{
                    'background-image': linearTop
                }"
            >
            </div>
            <img class="head-img" align="center" :src="$root.officialBigImg">
        </div>
        <div class="content-wrapper" :style="{'background-image': linearBottom}">
            <div class="top"></div>
            <div class="bottom">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        computed: {
            linearTop() {
                return `linear-gradient(180deg, ${this.$root.officialBackgroundColor} 0%, transparent 11.92vw)`;
            },
            linearBottom() {
                return `linear-gradient(180deg, transparent 0%, ${this.$root.officialBackgroundColor} 100%)`;
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;

    .official-header {
        position: relative;
        width: px2rem(1242);
        max-width: px2rem(1242);
        overflow-x: hidden;
        .img-wrapper {
            position: relative;
            display: flex;
            justify-content: center;
            .top-mask {
                position: absolute;
                width: 100%;
                height: 100%;
            }
            .head-img {
                height: 100vw
            }
        }
        .content-wrapper {
            position: absolute;
            top: 0;
            bottom: 0;
            width: px2rem(1242);
            display: flex;
            flex-direction: column;
            .top {
                flex-grow: 1;
            }
            .bottom {
                padding-left: px2rem(51);
                padding-right: px2rem(51);
            }
        }
    }
</style>